import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';

import HomePage from '@/pages/HomePage.vue';
import DetailPage from '@/pages/DetailPage.vue';
import ModulePage from '@/pages/ModulePage.vue';
import VideoPage from '@/pages/VideoPage.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';
import type { ModuleRouteName } from '@/composables/module-target';

function moduleRoutes(routeName: ModuleRouteName): readonly RouteRecordRaw[] {
  return [
    {
      path: `/${routeName}`,
      name: `${routeName}-index`,
      component: ModulePage,
      props: { routeName },
      meta: { moduleRouteName: routeName },
    },
    {
      path: `/${routeName}/:moduleId`,
      name: `${routeName}-module`,
      component: ModulePage,
      props: { routeName },
      meta: { moduleRouteName: routeName },
    },
  ];
}

/**
 * 前台路由表（ADR-0001 修订：vue-router history mode）。
 *
 * - `/` ：首页长页 + 锚点导航（HomePage）。
 * - `/detail/:sectionId/:slug?` ：详情页（DetailPage）。
 *   - `sectionId` 是 Section 的稳定身份（Guid 字符串），刷新时由路由参数恢复。
 *   - `slug` 仅作展示用 URL 美化，缺失或不匹配时不影响渲染（F10 实现时
 *     用 `history.replaceState` 修正为当前 Section title slug）。
 * - 未匹配路径走 NotFoundPage —— Debug-First：显式 404 而非静默跳首页。
 *
 * nginx 前台 location 需配 `try_files $uri $uri/ /index.html` 才能支持
 * history mode 的深链刷新（F09 部署 issue 落地）。
 */
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  ...moduleRoutes('achievement-intro'),
  ...moduleRoutes('application-form'),
  ...moduleRoutes('summary-report'),
  ...moduleRoutes('promotion-effect'),
  ...moduleRoutes('support-material'),
  {
    path: '/achievement-video',
    name: 'achievement-video-index',
    component: VideoPage,
    meta: { moduleRouteName: 'achievement-video' },
  },
  {
    path: '/detail/:sectionId/:slug?',
    name: 'detail',
    component: DetailPage,
    props: true,
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: NotFoundPage,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
